import { LoadingPageSkeleton } from "./enhanced-skeletons";

export const PageLoader = () => {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="w-full max-w-6xl">
        <LoadingPageSkeleton />
      </div>
    </div>
  );
};

export const SimplePageLoader = () => {
  return (
    <div
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-slate-50 via-slate-100 to-slate-200 dark:from-[#0a0a0a] dark:via-[#0f172a] dark:to-[#0c1222]"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className="relative text-center">
        <div
          className="mx-auto size-14 rounded-full border-[3px] border-[#268599]/25 border-t-[#268599] motion-safe:animate-spin motion-reduce:animate-none motion-reduce:border-t-[#268599]"
          aria-hidden
        />
        <p className="mt-6 bg-gradient-to-r from-[#268599] to-orange-600 bg-clip-text font-sans text-lg font-semibold tracking-wide text-transparent">
          Stylion
        </p>
        <p className="mt-2 font-sans text-sm text-muted-foreground">Loading…</p>
      </div>
    </div>
  );
};
